/**
 * @generated SignedSource<<5f78dc9c2bc8368ba20af6c07d8be49a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineTopNav_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineTopAppliedFilters_user" | "SbRespRefineTopFilters_user" | "SbRespRefineMenuDrawer_user">;
  readonly " $fragmentType": "SbRespRefineTopNav_user";
};
export type SbRespRefineTopNav_user$key = {
  readonly " $data"?: SbRespRefineTopNav_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineTopNav_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineTopNav_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopAppliedFilters_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopFilters_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuDrawer_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b4197037e301f58d7d38d722e58d5f14";

export default node;
